export default __webpack_public_path__ + "static/media/build.d46ee726.svg";